import { Component } from '@angular/core';
import { simpleFade } from '../../../../assets/animations/animations';

@Component({
  selector: 'app-slider-view',
  templateUrl: './slider-view.component.html',
  styleUrls: ['./slider-view.component.scss'],
  animations: [simpleFade],
  host: {
    '[class.isActive]': 'active',
  },
  imports: [],
})
export class SliderViewComponent {
  active = false;
  public valid = true;
}
